export const FooterPanel = () => {
    return (
        <footer className="bg-gray-200 p-2 text-center text-xs font-medium">
            <p>El Boske Estudio de Mezcla&copy; 2024 diseñada por Jaime Alonso García-Amorena</p>
        </footer>
    );
}
